module.exports = evite.exports.ReactDomClient;